module.exports = __webpack_public_path__ + "img/33ne.28cf4ef1.svg";